// extracted by mini-css-extract-plugin
export default {"quickLinks":"quick-links_quickLinks__cePnc","links":"quick-links_links__F7rjd","S":"quick-links_S__fctqL"};